// Signature: c0c9243d7a89e36a4f7f2bb694246fa6ba7f8aff61512d5ff3c81f97961453c6
/*
    Этот файл был создан автоматически.
    НЕ ИЗМЕНЯЙТЕ ЕГО ВРУЧНУЮ!
    Вместо изменения вручную используйте `easy-breezy`
*/
import { createApi, baseQuery, enhanceEndpoints, injectEndpoints } from './extension';
import type * as v1ContractsSpecialActivePut from './v1/contracts/special/active/put';
import type * as v1PaymentGeneratePost from './v1/payment/generate/post';
import type * as v1PaymentStatusGet from './v1/payment/status/get';
import type * as v2AutoAdvertIdDelnmPost from './v2/auto/{advertID}/delnm/post';
import type * as v2AutoAdvertIdGetcpmGet from './v2/auto/{advertID}/getcpm/get';
import type * as v2AutoAdvertIdNewnmGet from './v2/auto/{advertID}/newnm/get';
import type * as v2AutoAdvertIdPlacementGet from './v2/auto/{advertID}/placement/get';
import type * as v2AutoAdvertIdSetExcludedPost from './v2/auto/{advertID}/set-excluded/post';
import type * as v2AutoAdvertIdSetcpmPost from './v2/auto/{advertID}/setcpm/post';
import type * as v2AutoAdvertIdStatWordsGet from './v2/auto/{advertID}/stat-words/get';
import type * as v2AutoIdActivePost from './v2/auto/{id}/active/post';
import type * as v2CarouselAuctionAdvertIdNewnmGet from './v2/carousel-auction/{advertID}/newnm/get';
import type * as v2CarouselAuctionAdvertIdPlacementGet from './v2/carousel-auction/{advertID}/placement/get';
import type * as v2CatalogAdvertIdNewnmGet from './v2/catalog/{advertID}/newnm/get';
import type * as v2CatalogAdvertIdPlacementGet from './v2/catalog/{advertID}/placement/get';
import type * as v2SeacatPlacesEstimatePost from './v2/seacat/places-estimate/post';
import type * as v2SeacatAdvertIdDelnmPost from './v2/seacat/{advertID}/delnm/post';
import type * as v2SeacatAdvertIdNewnmGet from './v2/seacat/{advertID}/newnm/get';
import type * as v2SeacatAdvertIdPlacementGet from './v2/seacat/{advertID}/placement/get';
import type * as v2SeacatAdvertIdSetActivePost from './v2/seacat/{advertID}/set-active/post';
import type * as v2SearchAdvertIdPlacementGet from './v2/search/{advertID}/placement/get';
import type * as v2SearchAdvertIdStatWordsGet from './v2/search/{advertID}/stat-words/get';
import type * as v2SearchIdSetPlusGet from './v2/search/{id}/set-plus/get';
import type * as v3ContractPost from './v3/contract/post';
import type * as v5AutoGetCpInfoGet from './v5/auto/get-cp-info/get';
import type * as v5AutoMultiSetcpmPost from './v5/auto/multi-setcpm/post';
import type * as v5AutoSetcpmPost from './v5/auto/setcpm/post';
import type * as v5AvailableCashbackPost from './v5/available-cashback/post';
import type * as v5CampaignInfoGet from './v5/campaign-info/get';
import type * as v5EventsExternalTrafficXlsGet from './v5/events-external-traffic/xls/get';
import type * as v5FullstatGet from './v5/fullstat/get';
import type * as v5GetClusterGet from './v5/get-cluster/get';
import type * as v5GetCpInfoGet from './v5/get-cp-info/get';
import type * as v5NewsGroupsByMonthGet from './v5/news/groups-by-month/get';
import type * as v5PaymentReceiptInternalTransactionGet from './v5/payments/receipt/{internal-transaction}/get';
import type * as v5PaymentsGet from './v5/payments/get';
import type * as v5PaymentsmonthlyGet from './v5/paymentsmonthly/get';
import type * as v5ProductsByNmsPost from './v5/products-by-nms/post';
import type * as v5ProductsGet from './v5/products/get';
import type * as v5SavePricePut from './v5/save-price/put';
import type * as v5SetActivePost from './v5/set-active/post';
import type * as v5SetNmCostPost from './v5/set-nm-cost/post';
import type * as v5SupplierLanguagePost from './v5/supplier/language/post';
import type * as v5UpdGet from './v5/upd/get';
import type * as v5WordsClustersGet from './v5/words-clusters/get';

export const base = createApi({
    reducerPath: 'api/campaigns',
    baseQuery  : baseQuery('/api'),
    endpoints  : (build) => ({
        v1ContractsSpecialActivePut: build.mutation<v1ContractsSpecialActivePut.TResponse, v1ContractsSpecialActivePut.IParameters>({
            query: (params) => ({
                method: 'PUT',
                url   : '/v1/contracts/special/active',
                body  : {
                    active: params.body.active,
                    id    : params.body.id
                },
                params: {
                    'contract-id': params.query['contract-id']
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v1PaymentGeneratePost: build.mutation<v1PaymentGeneratePost.TResponse, v1PaymentGeneratePost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v1/payment/generate',
                body  : {
                    sum: params.body.sum
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v1PaymentStatusGet: build.query<v1PaymentStatusGet.TResponse, v1PaymentStatusGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v1/payment/status',
                params: {
                    transaction: params.query.transaction
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdDelnmPost: build.mutation<v2AutoAdvertIdDelnmPost.TResponse, v2AutoAdvertIdDelnmPost.IParameters>({
            query: (params) => ({
                method : 'POST',
                url    : `/v2/auto/${params.path.advertID}/delnm`,
                body   : params.body,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdGetcpmGet: build.query<v2AutoAdvertIdGetcpmGet.TResponse, v2AutoAdvertIdGetcpmGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/auto/${params.path.advertID}/getcpm`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdNewnmGet: build.query<v2AutoAdvertIdNewnmGet.TResponse, v2AutoAdvertIdNewnmGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/auto/${params.path.advertID}/newnm`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdPlacementGet: build.query<v2AutoAdvertIdPlacementGet.TResponse, v2AutoAdvertIdPlacementGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/auto/${params.path.advertID}/placement`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdSetcpmPost: build.mutation<v2AutoAdvertIdSetcpmPost.TResponse, v2AutoAdvertIdSetcpmPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : `/v2/auto/${params.path.advertID}/setcpm`,
                body  : {
                    cpm: params.body.cpm,
                    nm : params.body?.nm
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdSetExcludedPost: build.mutation<v2AutoAdvertIdSetExcludedPost.TResponse, v2AutoAdvertIdSetExcludedPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : `/v2/auto/${params.path.advertID}/set-excluded`,
                body  : {
                    excluded: params?.body?.excluded
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoAdvertIdStatWordsGet: build.query<v2AutoAdvertIdStatWordsGet.TResponse, v2AutoAdvertIdStatWordsGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/auto/${params.path.advertID}/stat-words`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2AutoIdActivePost: build.mutation<v2AutoIdActivePost.TResponse, v2AutoIdActivePost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : `/v2/auto/${params.path.id}/active`,
                body  : {
                    booster : params.body.booster,
                    carousel: params.body.carousel
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2CarouselAuctionAdvertIdNewnmGet: build.query<v2CarouselAuctionAdvertIdNewnmGet.TResponse, v2CarouselAuctionAdvertIdNewnmGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/carousel-auction/${params.path.advertID}/newnm`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2CarouselAuctionAdvertIdPlacementGet: build.query<v2CarouselAuctionAdvertIdPlacementGet.TResponse, v2CarouselAuctionAdvertIdPlacementGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/carousel-auction/${params.path.advertID}/placement`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2CatalogAdvertIdNewnmGet: build.query<v2CatalogAdvertIdNewnmGet.TResponse, v2CatalogAdvertIdNewnmGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/catalog/${params.path.advertID}/newnm`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2CatalogAdvertIdPlacementGet: build.query<v2CatalogAdvertIdPlacementGet.TResponse, v2CatalogAdvertIdPlacementGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/catalog/${params.path.advertID}/placement`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SeacatAdvertIdDelnmPost: build.mutation<v2SeacatAdvertIdDelnmPost.TResponse, v2SeacatAdvertIdDelnmPost.IParameters>({
            query: (params) => ({
                method : 'POST',
                url    : `/v2/seacat/${params.path.advertID}/delnm`,
                body   : params.body,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SeacatAdvertIdNewnmGet: build.query<v2SeacatAdvertIdNewnmGet.TResponse, v2SeacatAdvertIdNewnmGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/seacat/${params.path.advertID}/newnm`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SeacatAdvertIdPlacementGet: build.query<v2SeacatAdvertIdPlacementGet.TResponse, v2SeacatAdvertIdPlacementGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/seacat/${params.path.advertID}/placement`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SeacatAdvertIdSetActivePost: build.mutation<v2SeacatAdvertIdSetActivePost.TResponse, v2SeacatAdvertIdSetActivePost.IParameters>({
            query: (params) => ({
                method : 'POST',
                url    : `/v2/seacat/${params.path.advertID}/set-active`,
                body   : params.body,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SeacatPlacesEstimatePost: build.mutation<v2SeacatPlacesEstimatePost.TResponse, v2SeacatPlacesEstimatePost.IParameters | void>({
            query: (params) => ({
                method: 'POST',
                url   : '/v2/seacat/places-estimate',
                body  : {
                    advertID    : params?.body?.advertID,
                    catalogPrice: params?.body?.catalogPrice,
                    searchPrice : params?.body?.searchPrice,
                    subject     : params?.body?.subject
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SearchAdvertIdPlacementGet: build.query<v2SearchAdvertIdPlacementGet.TResponse, v2SearchAdvertIdPlacementGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/search/${params.path.advertID}/placement`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SearchAdvertIdStatWordsGet: build.query<v2SearchAdvertIdStatWordsGet.TResponse, v2SearchAdvertIdStatWordsGet.IParameters>({
            query: (params) => ({
                method : 'GET',
                url    : `/v2/search/${params.path.advertID}/stat-words`,
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v2SearchIdSetPlusGet: build.mutation<v2SearchIdSetPlusGet.TResponse, v2SearchIdSetPlusGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : `/v2/search/${params.query.id}/set-plus`,
                params: {
                    fixed: params.query.fixed,
                    id   : params.query.id
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v3ContractPost: build.mutation<v3ContractPost.TResponse, v3ContractPost.IParameters | void>({
            query: (params) => ({
                method : 'POST',
                url    : '/v3/contract',
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5AutoGetCpInfoGet: build.query<v5AutoGetCpInfoGet.TResponse, v5AutoGetCpInfoGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/auto/get-cp-info',
                params: {
                    advert_id: params.query.advert_id
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5AutoMultiSetcpmPost: build.mutation<v5AutoMultiSetcpmPost.TResponse, v5AutoMultiSetcpmPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/auto/multi-setcpm',
                body  : {
                    advertId: params.body.advertId,
                    cpm     : params.body?.cpm,
                    cpo     : params.body?.cpo,
                    cpc     : params.body?.cpc,
                    nms     : params.body?.nms,
                    minCPC  : params.body?.minCPC,
                    minCPO  : params.body?.minCPO,
                    model   : params.body.model
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5AutoSetcpmPost: build.mutation<v5AutoSetcpmPost.TResponse, v5AutoSetcpmPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/auto/setcpm',
                body  : {
                    advertId      : params.body.advertId,
                    cpm           : params.body?.cpm,
                    cpo           : params.body?.cpo,
                    cpc           : params.body?.cpc,
                    nm            : params.body?.nm,
                    minCPC        : params.body?.minCPC,
                    minCPO        : params.body?.minCPO,
                    model         : params.body.model,
                    disable_low_cr: params.body?.disable_low_cr
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5AvailableCashbackPost: build.mutation<v5AvailableCashbackPost.TResponse, v5AvailableCashbackPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/available-cashback',
                body  : {
                    sum: params.body.sum
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5CampaignInfoGet: build.query<v5CampaignInfoGet.TResponse, v5CampaignInfoGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/campaign-info',
                params: {
                    advertID: params.query.advertID
                }
            })
        }),
        v5EventsExternalTrafficXlsGet: build.query<v5EventsExternalTrafficXlsGet.TResponse, v5EventsExternalTrafficXlsGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/events-external-traffic/xls',
                params: {
                    beginDate: params.query.beginDate,
                    endDate  : params.query.endDate
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5FullstatGet: build.query<v5FullstatGet.TResponse, v5FullstatGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/fullstat',
                params: {
                    advertID     : params.query.advertID,
                    from         : params.query?.from,
                    to           : params.query?.to,
                    appType      : params.query?.appType,
                    order        : params.query?.order,
                    direction    : params.query?.direction,
                    placementType: params.query?.placementType
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5GetClusterGet: build.query<v5GetClusterGet.TResponse, v5GetClusterGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/get-cluster',
                params: {
                    advertID: params.query.advertID,
                    cluster : params.query.cluster
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5GetCpInfoGet: build.query<v5GetCpInfoGet.TResponse, v5GetCpInfoGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/get-cp-info',
                params: {
                    advert_id: params.query.advert_id
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5NewsGroupsByMonthGet: build.query<v5NewsGroupsByMonthGet.TResponse, v5NewsGroupsByMonthGet.IParameters | void>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/news/groups-by-month',
                params: {
                    limit : params?.query?.limit,
                    offset: params?.query?.offset
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5PaymentReceiptInternalTransactionGet: build.query<v5PaymentReceiptInternalTransactionGet.TResponse, v5PaymentReceiptInternalTransactionGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : `/v5/payments/receipt/${params.path['internal-transaction']}`
            })
        }),
        v5PaymentsGet: build.query<v5PaymentsGet.TResponse, v5PaymentsGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/payments',
                params: {
                    page_number: params.query.page_number,
                    page_size  : params.query.page_size,
                    from_date  : params.query?.from_date,
                    to_date    : params.query?.to_date,
                    type       : params.query?.type
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5PaymentsmonthlyGet: build.query<v5PaymentsmonthlyGet.TResponse, v5PaymentsmonthlyGet.IParameters | void>({
            query: (params) => ({
                method : 'GET',
                url    : '/v5/paymentsmonthly',
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5ProductsByNmsPost: build.mutation<v5ProductsByNmsPost.TResponse, v5ProductsByNmsPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/products-by-nms',
                body  : {
                    type: params.body.type,
                    nms : params.body.nms
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5ProductsGet: build.query<v5ProductsGet.TResponse, v5ProductsGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/products',
                params: {
                    subject     : params.query.subject,
                    payment_type: params.query.payment_type
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5SavePricePut: build.mutation<v5SavePricePut.TResponse, v5SavePricePut.IParameters>({
            query: (params) => ({
                method: 'PUT',
                url   : '/v5/save-price',
                body  : {
                    advert_id : params.body.advert_id,
                    subject_id: params.body.subject_id,
                    menu_id   : params.body?.menu_id,
                    price     : params.body.price
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5SetActivePost: build.mutation<v5SetActivePost.TResponse, v5SetActivePost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/set-active',
                body  : {
                    advert_id : params.body.advert_id,
                    subject_id: params.body.subject_id,
                    menu_id   : params.body?.menu_id,
                    active    : params.body.active
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5SetNmCostPost: build.mutation<v5SetNmCostPost.TResponse, v5SetNmCostPost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/set-nm-cost',
                body  : {
                    advert_id: params.body?.advert_id,
                    costs    : params.body.costs
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5SupplierLanguagePost: build.mutation<v5SupplierLanguagePost.TResponse, v5SupplierLanguagePost.IParameters>({
            query: (params) => ({
                method: 'POST',
                url   : '/v5/supplier/language',
                body  : {
                    language: params.body.language
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5UpdGet: build.query<v5UpdGet.TResponse, v5UpdGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/upd',
                params: {
                    from      : params.query?.from,
                    to        : params.query?.to,
                    search    : params.query?.search,
                    pageNumber: params.query.pageNumber,
                    pageSize  : params.query.pageSize,
                    type      : params.query.type
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        }),
        v5WordsClustersGet: build.query<v5WordsClustersGet.TResponse, v5WordsClustersGet.IParameters>({
            query: (params) => ({
                method: 'GET',
                url   : '/v5/words-clusters',
                params: {
                    advertID: params.query.advertID
                },
                headers: {
                    'X-SupplierId': params?.header?.['X-SupplierId']
                }
            })
        })
    })
});
export const api = injectEndpoints(base);
enhanceEndpoints(api);

export default api;
